import { forwardRef, createElement } from 'react';

function IconInfo(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M11.917 9.355c.406-.018.793.073 1.133.31.962.674.524 2.404-.048 3.869l-.158.391-.237.55-.455 1.002-.078.188c-.01.027-.02.051-.027.073-.561 1.637.086 2.057 1.037 1.797l.103-.03-.069.77c-1.848 1.337-4.443.961-3.364-2.283.052-.156.122-.33.204-.52l.176-.393.398-.867.2-.457c.385-.92.675-1.867.453-2.548-.164-.5-.684-.534-1.214-.352l-.114.042.068-.711c.543-.42 1.177-.732 1.79-.813l.202-.018zM13.148 5c.747 0 1.352.609 1.352 1.362 0 .75-.605 1.36-1.352 1.36a1.357 1.357 0 01-1.354-1.36c0-.753.605-1.362 1.354-1.362z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Info = /*#__PURE__*/forwardRef(IconInfo);

export default Info;
//# sourceMappingURL=Info.js.map
